export const StainlessSteelCoilsData = [
  {
    text1:
      "Stainless Steel Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Extraordinary earths metals in these SS Plates, generally cerium, increase the degree of nucleation locale for the oxide, which results in a fine grained chromium and silica scale. We similarly offer the proportionate in different examinations, for instance, Stainless Steel 304 Sheets Plates Coils & Stirps",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      Application:
        "Off-Shore Oil Drilling Companies Power Generation Petrochemicals Gas Processing Specialty Chemicals Pharmaceuticals Pharmaceutical Equipment Chemical Equipment Sea Water Equipment Heat Exchangers Condensers Pulp and Paper Industry",
    },
    chemical: {},
  },
];

export const StainlessSteel201CoilsData = [
  {
    text1:
      "Stainless Steel 201 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Modi Metals. co.is Stocking expansive extent of 201 Stainless steel Coils & Stirps  Suppliers in India. We present ourselves as one of the principle Exporter and Importer of 201 tempered steel Coils & Stirps  Distributor in India, AISI 201 SS Coils & Stirps , Stainless Steel S20100 Coils & Stirps , 201 Stainless Steel Coils & Stirps  Suppliers in Mumbai, Maharashtra, ASTM A240 Grade 201 SS Coils & Stirps . It is seen as a celebrated name for 201 solidified steel Coils & Stirps  trader in India and Asian Market that Suppliers and supplier of Embossed 201 Stainless Steel Coils & Stirps , 201 tempered steel Coils & Stirps  supplier in India, UNS S20100 SS 201 Coils & Stirps , We offer Stainless Steel Perforated Coils & Stirps  in different kind of thickness, assurance, assessments and estimations, Perforated 201 Stainless Steel Coils & Stirps  Stockist in India, Bright Hammered Pattern Decorative 201 SS Coils & Stirps , Supplier of 201 Stainless Steel Coils & Stirps  in India.",
    Specifications: {
      Item: "Stainless Steel 201 Coils & Stirps (Hot rolled, cold rolled)",
      Standard: "JIS, AISI, ASTM, GB, DIN, EN, etc",
      Surface:
        "the surface and finish of stainless steel 201 Coils & Stirps : 2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Thickness: "0.3~10.0mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      "Brand:":
        " Indian Origin, European Origin, Japanese Origin, US Origin, Korea Origin, Thailand Origin, Taiwan Origin",
      "Suppliers:":
        "POSCO, Aperam, Jindal Stainless, DKC Korea, Thyssenkrup, Baosteel, TISCO, Arcelor Mittal, VDM, Nippon Metal, Outokumpu",
      Package:
        "Standard export package, suit for all kinds of transport, or as required.",
    },
    chemical: {},
  },
];

export const StainlessSteel202CoilsData = [
  {
    text1:
      "Stainless Steel 202 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "202 Stainless Steel Coil & Stirp in India, We are no.1 vendor of AISI 202 Coil & Stirp. We are furthermore Suppliers of 202 solidified steel Coil & Stirp in India, SS 202 DIN 1.4373, We are stacking 300 Ton UNS S20200 Coil & Stirp of prominent producer of tempered steel 202 infection moved Coil & Stirp. If you are scanning for greatest supplier of 202 Stainless Steel Coil & Stirp in India, Hot Rolled 202 SS Coil & Stirp shipper, Navpad Steel can offer you outright best cost of ASTM/ASME A240 202 Stainless Steel Coil & Stirp in most concise movement time. It is Wholesaler of SS Coil & Stirp of Baosteel, ThyssenKrupp, Arcelor Mittal, Nas, KDC Korea. We are offering interesting expense on surplus heap of WERKSTOFF NO. 1.4373 202 Coil & Stirp in India. As a one of the greatest Stockholder of DKC Korea 202 Stainless Steel Coil & Stirp in Mumbai, Maharashtra, India.",
    Specifications: {
      Item: "Stainless Steel 202 Coil & Stirp(Hot rolled, cold rolled)",
      Standard: "JIS, AISI, ASTM, GB, DIN, EN, etc",
      Surface:
        "the surface and finish of stainless steel 201 Coil & Stirp: 2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Thickness: "0.3~10.0mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      "Brand:":
        " Indian Origin, European Origin, Japanese Origin, US Origin, Korea Origin, Thailand Origin, Taiwan Origin",
      "Suppliers:":
        "POSCO, Aperam, Jindal Stainless, DKC Korea, Thyssenkrup, Baosteel, TISCO, Arcelor Mittal, VDM, Nippon Metal, Outokumpu",
      Package:
        "Standard export package, suit for all kinds of transport, or as required.",
    },
    chemical: {},
  },
];

export const StainlessSteel304CoilsData = [
  {
    text1:
      "Stainless Steel 304 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 304 Coils & Stirps despite accessible in the couple of develop sizes and ranges. You can incline toward the thickness that you need to buy for your forefront applications. After a short time, see its quality then it is besides dazzling. Its yield quality and unbending nature makes it reasonable for each mechanical application. One more thing about this thing is it will all around be utilized in any sort of temperatures.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const StainlessSteel304LCoilsData = [
  {
    text1:
      "Stainless Steel 304l Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "We pass on the Stainless Steel 304L Coils & Stirps with valid bundling, we spread this SS twists in wooden case or holders so as to maintain a strategic distance from outside harm. We have a review and testing gathering, they can test the SS coast on different parameters to guarantee the probability of the finished result and the thing is also attempted by inaccessible examination gathering. We have passed on tempered steel 304L breeze with standard test validations and this thing is strengthened by different affiliations or private lab tes",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const StainlessSteel304HCoilsData = [
  {
    text1:
      "Stainless Steel 304H Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "This material is commonly used in the constructional applications and with that in various applications like in all the all the more sizzling, condensers, oil purifiers, steam handicaps, and so on. In like manner, it passes on the higher quality in the raised temperature that makes it best to be used in countless the application where the temperature remains high always. Tempered Steel 304H Coils & Stirps are besides used in unending the electric age plants in light of its make and tremendous quality.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel310SCoilsData = [
  {
    text1:
      "Stainless Steel 310S Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The Stainless Steel 310s Coils & Stirps comes in ASTM A240/BS 4449/JIS G3109. The tempered steel turn in width: 1000mm, 1220mm, 1250mm, 1500mm, length: 2000mm, 2440mm, 3000mm, 5800mm. 6000mm, and so on. This assessment of Ss circle is appeared to be various surface covering like 2B, 2D, BA, mirrors, sandblast, hairline and others. The SS 310S float seemed to changed structures like setting, hot moved, cold rolled and others.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel310HCoilsData = [
  {
    text1:
      "Stainless Steel 310H Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Made Steel 310H Coils & Stirps, said to be the best unavoidable unpreventable delayed consequence of the market since it has a higher quality rate that makes it solid and adaptable thing. The bleeding edge clients utilize these turns in savage degrees of their mechanical applications since they handle its highlights are gigantic and the usage of right blend makes it best to be utilized in any of the compound based applications.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const StainlessSteel316CoilsData = [
  {
    text1:
      "Stainless Steel 316 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Stainless Steel 316 Coils & Stirps Supplierss In India, Stainless Steel 316 Coils & Stirps Exporters In India, Stainless Steel 316 Coils & Stirps Suppliers In India, Stainless Steel 316 Coils & Stirps Importers In India, Stainless Steel 316 Coils & Stirps Stockists In India",
    text3:
      "The Modi Metals is the standard provider of Stainless Steel 316 Coils & Stirps thing. We pass on this thing by the best bundling; we spread this float in wooden case or holders to stay away from outside discernment condition. We supply stunning nature of treated steel thing in the unquestionable field and we are budgetary pro and vender of SS 316 circle. We cause SS to coast with different standard test confirmation and bolstered by an other research center test. Before dispatching last result to the customer we have done legitimate testing to guarantee the probability of the last result.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel316LCoilsData = [
  {
    text1:
      "Stainless Steel 316L Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 316L Coils & Stirps are in like way contained the best carbon 0.03 %, manganese max 2%, and nickel 10-14%. Near to this, there are altogether continuously produced substances used to fortify this evaluation of the turns. Also, the acknowledgment of the turns hoarding process it goes under testing division where its varying quality endeavored by a social occasion of specialists. As it is even sorted out by the requesting of the clients so it is vital for the producer to append all the affirmed papers or report with the thing at the time of shipment.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel316HCoilsData = [
  {
    text1:
      "Stainless Steel 316H Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The Stainless Steel 316H Coils & Stirps is tried by different physical and substance tests and are endeavored by a closed off assessment get-together to guarantee the probability of the finished result. We are passing on this Ss thing with fitting bundling utilizing wooden boxes and compartments to keep up a fundamental piece from any sort of outside perniciousness. You can get this thing from our shop at spurned market rates.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel316TiCoilsData = [
  {
    text1:
      "Stainless Steel 316Ti Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 316Ti Coils & Stirps hold the mechanical and physical properties this is truly similar to the standard grade. It is used in unending the affiliations like substance, generator, electrical and solid endeavors. Other than this, its range and sizes what's more get combination as shown by the need of the customers. If you are what's more hunting down the best grade of circles, by then we will propose you go with this option.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const StainlessSteel904LCoilsData = [
  {
    text1:
      "Stainless Steel 904L Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Coils & Stirps are made with the help of endeavored foul materials for expanding high measure. Increased used ground machines for gathering these circles with the objective that it increment most verifiable surface finishing and dimensional precision. These are open in most reasonable expenses. Stainless Steel 904L Coils & Stirps gives whole game plan relationship to dealing with applications. All of passed on turns experience amazing quality test for debilitating left circles for quality mentioning. These are squashed as packs for easy to passing on and avowing. Use these circles for reestablishing your various applications.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel410SCoilsData = [
  {
    text1:
      "Stainless Steel 410S Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The 410S tempered steel circle is ferritic in the toughened condition. It is used in various current applications and is made to fulfill all the specific essentials of the clients. We supply Ss circles in extraordinarily made size, thickness, and width. The SS 410S twist is supply with various surfaces FINISH-2B/BA/MIRROR. This is design to meet all inclusive similarly as neighborhood checks. It comes in ASTM A240/ASME SA240/UNS S41008, SS 410S and another estimation like API, ASTM, and ASME. The thickness of these twists is stretching out from 4mm to 100mm. This twist is invest huge energy in various structures like shim circle, punctured circle, and B.Q. profile. This twist is presented to various surface coatings like hot moved, cold rolled.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const StainlessSteel420CoilsData = [
  {
    text1:
      "Stainless Steel 420 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Contiguous this, on this treated steel, the use of carbon is there that work on the utilization hindrance property and this keeps the thing stay from the rust for long. Consummation 2B/HR is one of its reason total in which they are in used and an enormous number of its customers are procuring this thing in light of its diverse working. Stainless Steel 420 Coils & Stirps, is one of the things which disguises all of the essentials of the customers in light of which customers use to get it. They know once they place assets into this things then they don't need to consider it. Thusly, in case you moreover need to purchase continue it is there in the market.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const InconelCoilsData = [
  {
    text1:
      "Inconel Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Testing conditions for these Inconel Alloy Plates meld saline conditions, for example, shoreline front zones where standard preface to ocean salt is commonplace and zones where de – icing salts are typical during winter.",
    Specifications: {
      Specifications: "ASTM / ASME SB 670",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Standard: "ASTM, ASME and API",
      Thickness: "0.1mm to 12 mm Thk",
      Specialize: "Shim Sheet, Designer Sheet, B. Q. Profile.",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Incoloy 925",
      Size: "000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",

    },
    chemical: {},
  },
];

export const Inconel600CoilsData = [
  {
    text1:
      "Inconel 600 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "These Alloy 600 Coils & Stirps gives insurance from different ordinary and inorganic blends, dissolvable game-plans and chloride – molecule stress – decay breaking too. Our Alloy 600 Slatting Coils & Stirps is fundamentally protected to chloride particle stress weakening breaking and is in like manner non – connecting with and impenetrable to a wide level of hazardous materials. In the meantime, these Alloy 600 Perforated Coils & Stirps are too being offered in different sizes and shapes to our customers.",
    Specifications: {
      Specifications: "ASTM / ASME SB 168",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {
      Grade: "Inconel 600",
      C: "0.15 max",
      Mn: "1.00 max",
      Si: "0.50 max\t",
      S: "0.015max",
      Cu: "0.50 max",
      Fe: "6.00 – 10.00",
      Ni: "72.00 min",
      Cr: "14.00 – 17.00",
    },
  },
];
export const Inconel601CoilsData = [
  {
    text1:
      "Inconel 601 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Nickel-Alloy 601 Sheets is every once in a while used for warm reactors in vapor plan of oil engines. Nickel-Alloy 601 Plates is what's more used for combustor parts and drive framework reinforces in mechanical get together for nitric harming age. These Nickel-Alloy 601 Coils & Stirps are additionally used in compartments, plate, and mechanical social affairs for warmth – treating gear. Liberal oils Inconel UNS N06601 Sheets Plates are used for tapping, penetrating, proposing or incapacitating. Meanwhile, these Alloy 601 Plates are nearly being offered in different sizes and shapes to our customers.",
    Specifications: {
      Specifications: "ASTM / ASME SB 168",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {
      Grade: "Inconel 601",
      C: "0.10 max",
      Mn: "1.00 max",
      Si: "0.50 max\t",
      S: "0.015max",
      Cu: "0.50 max",
      Fe: "Balance",
      Ni: "58.0 – 63.0",
      Cr: "21.0 – 25.0",
    },
  },
];
export const Inconel625CoilsData = [
  {
    text1:
      "Inconel 625 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The high molybdenum substance makes Alloy 625 Slatting Coils & Stirps particularly impervious to setting and opening use. Gigantic markets for Alloy 625 Perforated Coils & Stirps include: Nuclear, Marine, Aerospace and Chemical Processing. The unimaginable and versatile disintegrating square of Inconel UNS N06625 Sheets Plates under a wide dimension of temperatures and loads is a basic explanation behind its wide affirmation in the blend overseeing field. Nickel Alloy 625 Sheets is routinely utilized in Aircraft ducting structures, Jet motor vapor frameworks and Engine push – reverser structures.",
    Specifications: {
      Specifications: "ASTM / ASME SB 168",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {
      Grade: "Inconel 625",
      C: "0.10 max",
      Mn: "0.50 max",
      Si: "0.50 max\t",
      S: "0.015max",
      Cu: "-",
      Fe: "5.0 max",
      Ni: "58.0 min",
      Cr: "20.0 – 23.0",
    },
  },
];

export const Inconel800CoilsData = [
  {
    text1:
      "Inconel 800/800H/800HT Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Incoloy 800 Slatting Coils & Stirps has splendid impenetrable to oxidation and carburization in high temperature conditions. Incoloy 800HT Perforated Coils & Stirps has an obliged science, inside the cutoff inspirations driving Incoloy 800H Perforated Coils & Stirps, and requires a glimmer treatment of 2100 Degree F (1149 Degree C) least. Inconel 800HT Coils & Stirps is in like manner used for valves, fittings and various parts familiar with hazardous device from 1100 Degree F to 1800 Degree F. Blend 800 Sheets Plates with a standard temper is recommended for relationship underneath 1100 Degree F (600 Degree C)",
    Specifications: {
      Specifications: "ASTM / ASME SB 409",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Standard: "ASTM, ASME and API",
      Thickness: "0.1mm to 12 mm Thk",
      Specialize: "Shim Sheet, Designer Sheet, B. Q. Profile.",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Incoloy 800",
      Size: "000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
    },
    chemical: {
      Grade: "Incoloy 800",
      Al: "0.15 – 0.60",
      Ti: "0.15 – 0.60",
      C: "0.10 max",
      Mn: "1.50 max",
      Si: "1.00 max",
      S: "0.015 max",
      Cu: "0.75 max",
      Fe: "39.50 min",
      Ni: "30.00 – 35.00",
      Cr: "19.00 – 23.00",
    },
  },
];

export const Inconel825CoilsData = [
  {
    text1:
      "Inconel 825 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "These Alloy 825 Perforated Coils & Stirps has remarkable mechanical properties from moderate to high temperatures, where standard machining structures utilized for iron based composites might be utilized. Incoloy UNS N08825 Sheets is particularly invulnerable to sulfuric and phosphoric acids, which further has phenomenal mechanical execution in both room temperature and up to 550 Degree C. These Incoloy 825 Sheets is balanced at the age line to disavow spread – granular use as – welded, where tooling ought to be, for example, to think about liberal clearances and radii. The basic property of Nickel-Alloy 825 Coils & Stirps is its utilization square. We in like way offer these Nickel-Alloy 825 Plates in incomparable best costs.",
    Specifications: {
      Specifications: "ASTM / ASME SB 424",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Standard: "ASTM, ASME and API",
      Thickness: "0.1mm to 12 mm Thk",
      Specialize: "Shim Sheet, Designer Sheet, B. Q. Profile.",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Incoloy 800",
      Size: "000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
    },
    chemical: {
      Grade: "Incoloy 800",
      Al: "0.02 max",
      Ti: "0.02 max",
      C: "0.05 max",
      Mn: "1.00 max",
      Si: "0.5 max",
      S: "0.03 max",
      Cu: "1.50 – 3.00",
      Fe: "22.00 min",
      Ni: "38.00 – 46.00",
      Cr: "19.50 – 23.50",
    },
  },
];

export const Inconel925CoilsData = [
  {
    text1:
      "Inconel 925 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The obstacle of these Incoloy 925 Perforated Coils & Stirps is made by the precipitation of the gamma mastermind through solubilization and creating warmth treatment, in order to keep up flexibility and quality at bizarre states. Standard machining structures utilized for iron based composites might be utilized, which checks Inconel 925 Sheets in diminishing and oxidizing condition. Titanium and aluminum in these Inconel 925 Plates structure some piece of the precipitation setting response that incredibly manufactures hardness and nature of the blend.",
    Specifications: {
      Specifications: "ASTM / ASME SB 424",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Standard: "ASTM, ASME and API",
      Thickness: "0.1mm to 12 mm Thk",
      Specialize: "Shim Sheet, Designer Sheet, B. Q. Profile.",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Incoloy 925",
      Size: "000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
    },
    chemical: {
      Grade: "Incoloy 925",
      Al: "0.03 max",
      Mo: "2.5 – 3.5",
      C: "0.03 max",
      Mn: "1.00 max",
      Si: "0.5 max",
      S: "0.03 max",
      Cu: "1.50 – 3.00",
      Fe: "22 min",
      Ni: "42 – 46",
      Cr: "19.55 – 22.5",
    },
  },
];

export const Inconel718CoilsData = [
  {
    text1:
      "Inconel 718 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "In the meantime, these Inconel 718 Slatting Coils & Stirps are in like manner being offered in different sizes and shapes to our customers. Welding of Inconel 718 Perforated Coils & Stirps in the made condition will cause the course of action of a diminished warmth – impacted zone. Composite 718 Plates is exceedingly resistant to chloride and sulfide stress disintegrating breaking. Basic livelihoods of Alloy 718 Coils & Stirps in the oil business are entry valves, spread stems, catches, tubing holders and fire safe valves. We moreover offer these Alloy 718 Perforated Coils & Stirps feature industry costs.",
    Specifications: {
      Specifications: "ASTM / ASME SB 670",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Standard: "ASTM, ASME and API",
      Thickness: "0.1mm to 12 mm Thk",
      Specialize: "Shim Sheet, Designer Sheet, B. Q. Profile.",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Incoloy 925",
      Size: "000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
    },
    chemical: {
      Grade: "Inconel 718",
      C: "0.08 max",
      Mn: "0.35 max",
      Si: "0.35 max",
      S: "0.015max",
      Cu: "0.30 max",
      Fe: "-",
      Ni: "50.00 – 55.00",
      Cr: "17.00 – 21.00",
    },
  },
];

export const MonelCoilsData = [
  {
    text1:
      "Monel Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "After the first machining pass, work setting in Monel Perforated Coils & Stirps will everything considered plastically turn either the work – piece or the contraption on coming about passes. We are dealing with our general customers beginning now and into the not so distant we give them Alloy 400 sheets, plates and bends at the ordained improvement time and at a reasonable expense. Thusly, you can at whatever point enthusiasm for magnificent Monel things from us.",
    Specifications: {
      Specifications: "ASTM / ASME SB 127",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const NickelCoilsData = [
  {
    text1:
      "Nickel Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "They fabricate these things recalling the necessities of customers and clients accessible around the world. Our point is to furnish our clients with a high bore of thing at a moderate cost, thusly we ensure that the majority of our things are particularly endeavored and crushed in the high bore of bundling material. There are different tests done to check the possibility of these things, for example, visual evaluation, untouchable examination, and positive material unquestionable affirmation testing, etc.",
    Specifications: {
      Specifications: "ASTM / ASME SB 168",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const TitaniumCoilsData = [
  {
    text1:
      "Titanium Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Titanium Coils & Stirps is correspondingly used in Automotive, Chemical Processing and Chlorate Manufacturing, Desalination, Architecture, Hydro Carbon Processing, Marine, Medical, and Power Generation. Titanium Slatting Coils & Stirps is typically used in light of the way that it sets unfathomable formability and moderate quality with inevitable use block. Titanium Perforated Coils & Stirps offers high use resistance in oxidizing, objective and delicately diminishing media, including chlorides.",
    Specifications: {
      Specifications: "ASTM / ASME SB265",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const TitaniumGrade1CoilsData = [
  {
    text1:
      'Titanium Grade 1 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India', 
    text2:
    '', 
    text3:'Titanium Grade 1 Sheets plates turns has different sorts, for example, titanium GR 1 Foils, Titanium GR 1 shim sheet, Titanium GR 1 Hot Rolled Plates, and so forth. This plate is open at sensible costs. This plate is used for making cathodic and anodes. It is accessible in standard crushing, for example, wooden boxes, stuffed round bar and significantly more. These Titanium Coils & Stirps are made out of titanium from 100% unadulterated plant things as demonstrated by ASTM Standard. These turns are conveyed using 1/2" - 2" dia channel or chamber as demonstrated by Titanium Grade 1 UNS R50250 Strip Coil for making them appropriate to warmth or cool the blend shower. These circles go about as an exchanger and are release endeavored before being given to the customers. We moreover make super tine "U" contorts according to exceptional sizes and shapes gave by our customers.',
    Specifications: {
      Standard: "JIS, AISI, ASTM, GB, DIN, EN, etc",
      Thickness: "0.3~10.0mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      Item: "Titanium Grade 1 UNS R50250 Strip(Hot rolled, cold rolled)",
    },
    chemical: {},
  },
];
export const TitaniumGrade2CoilsData = [
  {
    text1:
      "Titanium Grade 2 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The affiliation considers the possibility of their things for every requesting which is bundled by them. Moreover, as indicated by the client's basic, the things are being bundled in wooden bed, case or as appeared by the thing standard. Additionally with this, affiliation likewise gives vital transportation reports to Titanium Gr 2 Sheets, Plates, Coils & Stirps. The thing is sent from plant to objective in favorable way and by different courses, either through street, payload or ocean. The affiliation has its business master which takes care about the bundling and passing on of the thing. It checks the volume and weight of the material briefs with the customers concerning the report shows to be polished for the thing when it is to be passed on out of India.",
    Specifications: {
      Specifications: "ASTM / ASME SB265",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const TitaniumGrade3CoilsData = [
  {
    text1:
      "Titanium Grade 3 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Titanium grade 3 Plate is accessible as Sheet, Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Clad Plate, Rolling Sheet, Flat Sheet, Rolling Plate and Flat Shim. The Titanium grade 3 Plate Weight Calculatorallows you to discover a check of the hugeness of various sizes of Cp Titanium Grade 3 Thin Sheet subject to estimations and shape. These sheets are sold in either 300mm or 600mm rolls and sheet structure. The thin material can be utilized in control plants, atomic plants or gas and oil refineries.",
    Specifications: {
      Specifications: "ASTM / ASME SB265",
      Thickness: "0.3mm to 150mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const TitaniumGrade4CoilsData = [
  {
    text1:
      "Titanium Grade 4 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "These sheets, bends, and plates in like way move concerning hardness where some can be made as touchy, hard and differing as spring hard, quarter hard or half hard. Considering their hardness they can be utilized in different applications. The titanium things should be conceivable as the hot moved plate, cold moved sheet, SATIN, 2B, BA NO (8) and 2 D. the evaluation 4 is the 5Al-2.5Sn composite that has different stock ends.",
    Specifications: {
      Specifications: "ASTM B265 / ASME SB 265 / AMS 4901",
      Thickness: "0.3mm to 150mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];
export const TitaniumGrade5CoilsData = [
  {
    text1:
      "Titanium Grade 5 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The Preston Pipes and Alloys are passing on the things with fine quality and logically basic capacity. We are in this business of progress for a long time and are giving our clients the delight in utilizing the finely assembled mechanical thing with much dependence and trust. We are giving the Titanium Alloy Gr 5 Sheets, Plates, Coils & Stirps at truly sensible costs which are completely palatable to our clients. You can control us through our site or the contact support. We give the 24x7 contact sponsorship to the request of our clients.",
    Specifications: {
      Specifications: "ASTM / ASME SB265",
      Thickness: "0.3mm to 150mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {},
  },
];

export const A286CoilsData = [
  {
    text1:
      "A-286 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "A-286 is in addition by and large utilized in gas turbines for low weight bowls and first and second stage turbine wheels, as it holds quality and usage obstruction at high temperatures. This additionally makes it perfect for max engine drive progression and vapor spouts. A-286 material is comparatively utilized by methods for vehicle creators in fumes valves and complex catch for its rigidity, creep quality and breaking down snag.",
    Specifications: {
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, Alloy",
      Thickness: "0.3mm to 150mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
      Diameter: "0.1 mm to 100 mm",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
    },
    chemical: {},
  },
];
export const SMO254CoilsData = [
  {
    text1:
      "SMO 254 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "SMO 254 Coils & Stirps is liberally more grounded than the normal austenitic assessments, with quality twice that of 300 strategy treated steel. Amalgam 254 Slatting Coils & Stirps is besides depicted by high adaptability and impact quality. With a lot of chromium, molybdenum, and nitrogen. SMO 254 Perforated Coils & Stirps is a basic bit of the time used in high chloride conditions, for instance, genuine water, seawater, squash creation line darken plants, and other chloride strategy streams. In unequivocal applications, 254 SMO Plates has even been accepted to be a continuously astute substitute for high nickel and titanium mixes.",
    Specifications: {
      " Specifications": "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const HastelloyCoilsData = [
  {
    text1:
      "Hastelloy Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "One of the focal qualities of Hastelloy Alloy Slatting Coils & Stirps is their assurance from chloride-actuated weight utilization part. The picked trademark name, Hastelloy Alloy Perforated Coils & Stirps is connected as the prefix name to more than twenty organized very utilize safe metal composites made by us.",
    Specifications: {
      " Specifications": "ASTM / ASME SB575",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {},
  },
];
export const Alloy20CoilsData = [
  {
    text1:
      "Alloy 20 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Manganese and nickel in Carpenter 20 Perforated Coils & Stirps chop down the eutectoid temperature and are known as austenite counterbalancing sections. With enough of these sections in Incoloy 20 Plates, the austenitic structure might be gotten at room temperature",
    Specifications: {
      " Specifications": "ASTM / ASME SB 463",
      Thickness: "0.1mm to 12 mm Thk",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {},
  },
];
export const DuplexCoilsData = [
  {
    text1:
      "Duplex Coils & Stirps,Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The Modi Metals supply and accreditation wide dimension of Duplex Steel Duplex Steel S31803/S32205 Coils & Stirps with various shapes and estimations. Duplex Steel S31803/S32205 turns is a not too awful decision for oil and gas applications by flawlessness of a typical than regular climatic utilize obstacle.",
    Specifications: {
      " Specifications": "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
    },
    chemical: {},
  },
];


export const  InconelCoilsGradeData=[

  {
    id:1,
    grade:'Inconel 600 Coils & Stirps',
    link:'/Inconel600CoilsGrade'
  },
  {
    id:2,
    grade:'Inconel 601 Coils & Stirps',
    link:'/Inconel601CoilsGrade'
  },
  {
    id:3,
    grade:'Inconel 625 Coils & Stirps',
    link:'/Inconel625CoilsGrade'
  },
  
  {
    id:4,
    grade:'Inconel 718 Coils & Stirps'
    ,
    link:'/Inconel718CoilsGrade'
  },
  {
    id:5,
    grade:' Inconel 800 Coils & Stirps',
    link:'/Inconel800CoilsGrade'
  },
  {
    id:6,
    grade:'Inconel 825 Coils & Stirps',
    link:'/Inconel825CoilsGrade'
  },
  {
      id:7,
      grade:'Inconel 925 Coils & Stirps',
      link:'/Inconel925CoilsGrade'
    },
]
export const MonelCoilsGradeData = [
  {
    id: 1,
    grade: "Monel 400 Coils & Stirps",
    link: "/Monel400Coils",
  },
  {
    id: 2,
    grade: "Monel K500 Coils & Stirps",
    link: "/MonelK500Coils",
  },
];
export const NickelCoilsGradeData = [
  {
    id: 1,
    grade: "Nickel 200 Coils & Stirps",
    link: "/Nickel200CoilsGrade",
  },
  {
    id: 2,
    grade: "Nickel 201 Coils & Stirps",
    link: "/Nickel201CoilsGrade",
  },
 
];

export const TitaniumCoilsGradeData = [
  {
    id: 1,
    grade: "Titanium Gr 1 Coils & Stirps",
    link: "/TitaniumGr1CoilsGrade",
  },
  {
    id: 2,
    grade: "Titanium Gr 2 Coils & Stirps",
    link:"/TitaniumGr2CoilsGrade",
  },
  {
    id: 3,
    grade: "Titanium Gr 3 Coils & Stirps",
    link: "/TitaniumGr3CoilsGrade",
  },
  {
    id: 4,
    grade: "Titanium Gr 4 Coils & Stirps",
    link: "/TitaniumGr4CoilsGrade",
  },
  {
    id: 5,
    grade: "Titanium Gr 5 Coils & Stirps",
    link: "/TitaniumGr5CoilsGrade",
  },
];


export const HastelloyCoilsGradeData = [
  {
    id: 1,
    grade: "Hastelloy B2 Coils & Stirps",
    link: "/HastelloyB2Coils",
  },
  {
    id: 2,
    grade: "Hastelloy B3 Coils & Stirps",
    link:"/HastelloyB3Coils",
  },
  {
    id: 2,
    grade: "Hastelloy C22 Coils & Stirps",
    link:"/HastelloyC22Coils",
  },
  {
    id: 2,
    grade: "Hastelloy C2000 Coils & Stirps",
    link:"/HastelloyC2000Coils",
  },
  {
    id: 2,
    grade: "Hastelloy C276 Coils & Stirps",
    link:"/HastelloyC276Coils",
  }, {
    id: 2,
    grade: "Hastelloy X Coils & Stirps",
    link:"/HastelloyXCoils",
  },
  
];









export const DuplexCoilsGradeData = [
  {
    id: 1,
    grade: "Duplex S31803 Coils & Stirps",
    link: "/DuplexS31803Coils",
  },
  {
    id: 2,
    grade: "Duplex 2101 Coils & Stirps",
    link:"/Duplex2101Coils",
  },
  {
    id: 3,
    grade: "Duplex 2205 Coils & Stirps",
    link:"/Duplex2205Coils",
  },
  {
    id: 4,
    grade: "Duplex 2304/S32304 Coils & Stirps",
    link:"/Duplex2304_S32304Coils",
  },
  {
    id: 5,
    grade: "SuperDuplex 2507 Coils & Stirps",
    link:"/SuperDuplex2507Coils",
  }, {
    id: 6,
    grade: "SuperDuplex S32750/S32760 Coils & Stirps",
    link:"/SuperDuplexS32750_S32760Coils",
  },
  
];

export const Monel400CoilsData = [
  {
    text1:
      "Monel 400 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Monel Alloy 400 Coils & Stirps, Monel 400 Circle, JIS NW 4400 Coils & Stirps, 400 Monel Hot Rolled Plates Supplier In Mumbai, India. Monel Werkstoff No 2.4360 Coils & Stirps, Monel 400 Slatting Coil, Monel 400 Coils & Stirps Dealer In India, Distributors Of ASME SB127 Monel 400 Coils & Stirps, 400 Monel Polished Cold Drawn Plates",
    text3:
      "This nickel compound is especially insusceptible to hydrochloric and hydrofluoric acids when they are de-coursed air through. As would be normal from its high copper content, Monel 400 is quickly struck by nitric hurting and smelling salts structures. Monel 400 has exceptional mechanical properties at underneath zero temperatures, can be utilized in temperatures up to 1000° F, and its dissolving point is 2370-2460° F. In the end, Monel 400 is low in quality in the propped condition thusly, a course of action of tempers might be utilized to develop the quality. The machinability of these Monel 400 Slatting Coils & Stirps (UNS N04400) is hard as it works-toughens all through machining. By then, Monel 400 Perforated Coils & Stirps are what's all the more being offered in various sizes and shapes to our clients. While these Alloy 400 Sheets has different flawless conditions, it is a long way from the ideal metal.",
    Specifications: {
      Specifications: "ASTM / ASME SB 127",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Monel Alloy 400 ",
    },
    chemical: {},
  },
];
export const MonelK500CoilsData = [
  {
    text1:
      "Monel Alloy K500 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Monel Alloy K500 Coils & Stirps, K500 Monel Circle, K500 Monel Hot Rolled Coils & Stirps Supplier In Mumbai, India. Monel Werkstoff No 2.4375 Coils & Stirps,Monel K500 Slatting Coil, Monel K500 Cold Rolled Coils & Stirps, Distributors Of ASME SB127 Monel K500 Coils & Stirps, K500 Monel Polished Cold Drawn Plates, K500 Monel Plate Stockholder, Monel K500 Strips Stockist, Suppliers.",
    text3:
      "The use limitation of Monel K500 is all around unclear from that of Monel 400 close to that when in the age-solidified condition, nickel amalgam K-500 has a clearly basic inclination toward stress-isolating part in express conditions. Monel K-500 has been acknowledged to be immune to a sharp gas condition. The blend of low use rates in expedient devour water and astonishing make compound K-500 especially reasonable for shafts of different partners in marine association. In stale or moderate moving ocean water, fouling may happen scanned for after by setting notwithstanding this setting backs off after a genuinely vivacious starting assault.",
    Specifications: {
      Specifications: "ASTM / ASME SB 127",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Monel Alloy K500 ",
    },
    chemical: {},
  },
];

export const Nickel200CoilsData = [
  {
    text1:
      "Nickel 200 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India ",
    text2:
      "Nickel Alloy Coils & Stirps,Nickel Hot Rolled Coils & Stirps Supplier In Mumbai, India. ASTM B162 Nickel Shim Sheets, Nickel Polished Cold Drawn Coils & Stirps, Distributors Of ASME SB162 Nickel Coils & Stirps, Nickel Strips Stockist, Suppliers. ",
    text3:
      "Nickel Coils & Stirps as they are the most referencing things. We as the vendor of nickel 200 things guarantee that most of our things are given to customers as shown by their bit of breathing space and principal. The things are made using better-quality nature of horrendous material. Likewise, the latest machines and progress is used for making a high bore of the material. We purchase these sheets, plates, and curves from the acknowledged and respected makers.",
    Specifications: {
      Specifications: "ASTM / ASME SB 168",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Nickel 200 Coils & Stirps",
    },
    chemical: {},
  },
];

export const Nickel201CoilsData = [
  {
    text1:
      "Nickel 201 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Nickel Alloy 200 Coils & Stirps, Nickel UNS N02200 Coils & Stirps, Nickel 200 Circle, ASME SB 162 Nickel 200 Coil, Hot Rolled Coils & Stirps Supplier In Mumbai, India. Nickel 200 Slatting Coil. Distributors Of ASME SB162 Nickel 200 Coils & Stirps, 200 Nickel Plate Stockholder, 200 Nickel Polished Cold Drawn Plates, Nickel 200 Strips Stockist, Suppliers.",
    text3:
      "The thing is essentially made of the nickel content with other obliged extent of substance content. A buoy of Nickel 201 is marvelously invulnerable to different synthetics and gives mind blowing conductivity to warm and electrical parts. Notwithstanding the way where that the sheets of this compound has outlandish drawing in, electrical and warm properties. These sheets have outstanding mechanical properties in it and momentous cleaving down to different media. These Alloy 201 Coils & Stirps are both enormous for checking and managing acidic ruinous, particularly in techniques where it is joined with formic hazardous and when air spread is missing (oxygen insists steel under such conditions), in any case it gives the best area of security from use.",
    Specifications: {
      Specifications: "ASTM / ASME SB 162",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Nickel 201 Coils & Stirps",
    },
    chemical: {},
  },
];

export const HastelloyB2CoilsData = [
  {
    text1:
      "Hastelloy B2 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Hastelloy B2 Sheets, ASTM B575 Hastelloy B2 Sheets, Hastelloy Alloy UNS N10665 Plates, Hastelloy B2 Coils, Hastelloy Alloy Workstoff NR. 2.4617 Slatting Coils, Hastelloy B2 Hot Rolled Sheets Stockists & Exporters Hastelloy Alloy B2 Sheets Suppliers, Hastelloy B2 Plates Supplier, Hastelloy B2 Coils & Circles Stockists In India,Hastelloy B2 Plates, DIN 2.4617 Hastelloy B2 Perforated Sheets, Hastelloy Alloy B2 Sheets Cut To Size, ASTM B575 Hastelloy B2 Shim Sheets, Hastelloy B2 Hot Rolled Plates, ASME SA B575 Hastelloy B2 Chequered Plates Dealer & Wholesalers.",
    text3:
      "We in any occasion, gathering Hastelloy Alloy B2 Plates dependent on the focal points and necessities of our clients. The sans rust, high strength and hardness offered by our things make it the most elevated purpose of the line in the general market. The Hastelloy B2 Hot Rolled Coils & Stirps and Hastelloy B2 Cold Rolled Plates are finely completed to guarantee faultlessness. They offer high versatility and check towards climatic purposes behind metal corruption. Obviously, Hastelloy B2 Checkered Plates and Hastelloy B-2 Polished Plates are relied upon to fulfill the standards of the national and overall markets. Our Hastelloy Alloy B2 Coils & Stirps list offers things to our clients at moderate costs and outstanding quality. The Hastelloy B2 Hot Rolled Coil and Hastelloy B2 Cold Rolled Coils & Stirps made by us are the prime necessities of the corrupting control and innovation arranging adventures. In any case, the Hastelloy B2 Slatting Coils & Stirps amassed by us locate a wide degree of utilization in the pound and paper things industry and waste treatment industry.",
    Specifications: {
      Specifications: "ASTM / ASME SB333",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B2 Coils & Stirps",
    },
    chemical: {
      Grade: "B2",
      Mo: "15.00 – 17.00",
      P: "0.04 max",
      C: "0.010 max",
      Mn: "1.00 max",
      Si: "0.08 max",
      S: "0.03 max",
      Co: "2.50 max",
      Ni: "50.99 min*",
      Cr: "14.50 – 16.50",
      Fe: "4.00 – 7.00",
    },
  },
];
export const HastelloyB3CoilsData = [
  {
    text1:
      "Hastelloy B3 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Hastelloy B3 Sheets, ASTM B575 Hastelloy B3 Sheets, Hastelloy Alloy UNS N010675 Plates, Hastelloy B3 Coils & Stirps, Hastelloy Alloy Werkstoff NR 2.4600 Slatting Coils & Stirps, Hastelloy B3 Hot Rolled Sheets Stockists & Exporters Hastelloy Alloy B3 Sheets Suppliers, Hastelloy B3 Plates Supplier, Hastelloy B3 Coils & Stirps & Circles Stockists In India,Hastelloy B3 Plates, DIN 2.4600 Hastelloy B3 Perforated Sheets, Hastelloy Alloy B3 Sheets Cut To Size, ASTM B575 Hastelloy B3 Shim Sheets, Hastelloy B3 Hot Rolled Plates, ASME SA B575 Hastelloy B3 Chequered Plates Dealer & Wholesalers",
    text3:
      "Our social affair focus is furnished with the most competent boss that administer the gathering procedure of Hastelloy B3 Plates. The things having a spot with our Hastelloy Alloy B-3 Plates stock offer high security from breaking down, flexibility and hardness. Our Hastelloy B3 Hot Rolled Coils & Stirps and Hastelloy B3 Cold Rolled Plates are conveyed dependent on the requesting of the petrochemical and pipework industry. They offer high pliability and confinement towards climatic purposes behind metal defilement. Our Hastelloy B-3 Polished Plates and Hastelloy B3 Checkered Plates seek after national and comprehensive measures and are repaired each quarterly.",
    Specifications: {
      Specifications: "ASTM / ASME SB333",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B3 Coils & Stirps",
    },
    chemical: {
      Grade: "B3",
      Ti: "0.2 max",
      Si: "10 max",
      Ni: "65.0 min",
      Mo: "28.5\t",
      Cr: "1.5",
      Fe: "1.5",
      W: "3.0 max",
      Mn: "3.0 max",
      C: "0.01 max",
      Al: "0.50 max",
    },
  },
];

export const HastelloyC22CoilsData = [
  {
    text1:
      "Hastelloy C22 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Hastelloy Alloy C22 Coils & Stirps, Hastelloy C22 Plates, Hastelloy C22 Circle, Alloy C22 Sheets, Hastelloy UNS N06022 Plates, ASME SB575 Hastelloy C22 Plate, JIS NW 6022 Plate, C22 Hastelloy Hot Rolled Plates Supplier In Mumbai, India.C22 Alloy Plate Exporter, Hastelloy C22 Cold Rolled Plates, ASTM B575 Hastelloy C22 Shim Sheets, Hastelloy Werkstoff No 2.4602 Sheets, Hastelloy C22 Sheets Dealer In India. C22 Hastelloy Polished Cold Drawn Plates, Hastelloy C22 Slatting Coil, C22 Hastelloy Plate Stockholder, Distributors Of ASME SB575 Hastelloy C22 Coils & Stirps, Hastelloy C22 Strips Stockist, Suppliers.",
    text3:
      "These features make Hastelloy c22 things broadly in like manner referencing. Unquestionably, when these things are made the packaging reason they go over couple of tests. The tests join hardness test, cleared examination, visual examination, positive material ID test, and so forth. These tests are finished by the need and under the impression of bosses to ensure the likelihood of these sheets, plates, and circles. Right when most by far of the tests are done, these Hastelloy c22 Sheets, Plates, Coils & Stirps are squashed in the high check of packaging material like wooden cases, beds, holders or social occasions that envisions rust and avoid harms. Beginning now and into the not too expelled, if you are what's more denied to buy Hastelloy c22 things visit Preston channels and amalgams today!",
    Specifications: {
      Specifications: "ASTM / ASME SB575",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B3 Coils & Stirps",
    },
    chemical: {
      Grade: "C22",
      Mo: "12.50 – 14.50",
      P: "0.02 max",
      C: "0.010 max",
      Mn: "0.50 max",
      Si: "0.08 max",
      S: "0.02 max",
      Co: "2.50 max",
      Ni: "50.015 min",
      Cr: "20.00 – 22.50",
      Fe: "2.00 – 6.00",
    },
  },
];

export const HastelloyC2000CoilsData = [
  {
    text1:
      "Hastelloy C2000 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "C2000 Hastelloy® Slit Coils & Stirps Stockholders, ASTM B575 Nickel Alloy C2000 Cold Rolled Sheets Manufactures, JIS NW 6200 Hastelloy® Alloy Chequer (Floor) Plate, Hastelloy C2000® Sheets Exporter,C-2000 Hastelloy Coils & Stirps, Hastelloy® Grade C2000 Shim Sheets Exporters, ASME SB575 Hastelloy Alloy C-2000 Chequered Plates, Hastelloy® C2000 Perforated Sheet Suppliers, Hastelloy C-2000® Sheets, Hastelloy® C2000 Alloy Plates In Mumbai India.Hastelloy® C2000 Flats, Hastelloy® Alloy C-2000 Slotted Hole Sheets, C2000 Hastelloy® Corrosion Resistant Plates Dealers In India, Hastelloy® C2000 Diamond Plate, Nickel Alloy C2000 Strip, Rolls Distributors, Hastelloy® C-2000 Coils & Stirps Dealer, UNS N06200 Hastelloy Hot Rolled Plates Stockists, Type C-2000 Hastelloy Alloy Rings In Mumbai. ",
    text3:
      "Composite C2000 Plates is astonishing among the versatile nickel-chromium-molybdenum materials in having a purposeful copper augmentation. So as to diminish the precipitation of second stage in the gleam affected welding zones of Alloy C2000 Coils & Stirps, high between relinquish temperature to 93 Degree C is cherished. Nickel C2000 Sheets >has remarkable mechanical properties at high temperatures, critical for a wide degree of flight and high temperature applications. The mix of Molybdenum and Copper in Nickel C2000 Plates give astonishing breaking down confirmation from diminishing media, while the high Chromium content gives extraordinary oxidizing obstacle. Nickel C2000 Coils & Stirps exhibit low entrance characteristics, as necessities be agreeable joint access (weld point) and irrelevant land are proposed. Precisely when specialists are making gear for Hastelloy UNS N06200 Sheets that can withstand the comprehensive sales that produced arranging can put on a machine, it is immense that the aggregate of the individual pieces inside the machine can hold up after some time.",
    Specifications: {
      Specifications: "ASTM / ASME SB575",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B3 Coils & Stirps",
    },
    chemical: {
      Grade: "Hastelloy C2000",
      Mo: "15.0-17.0",
      P: ".04 max",
      W: "3.0-4.5",
      V: ".35 max",
      C: "0.010 max",
      Mn: "1.0 max",
      Si: "0.08 max",
      Co: "2.50 max",
      Ni: "Remainder",
      Cr: "14.5-16.5",
      Fe: "4.0-7.0",
    },
  },
];

export const HastelloyC276CoilsData = [
  {
    text1:
      "Hastelloy C276 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Hastelloy Alloy C276 Coils & Stirps,Hastelloy C276 Circle, Hastelloy C276 Slatting Coil, C276 Hastelloy Hot Rolled Plates Supplier In Mumbai, India. C276 Hastelloy Coils & Stirps Stockholder, Distributors Of ASME SB575 Hastelloy C276 Coils & Stirps, C276 Hastelloy Polished Cold Drawn Coils & Stirps, Hastelloy GOST ХН65МВУ Strips Stockist, Suppliers.",
    text3:
      "Hastelloy C276 Coils & Stirps can be warmth treated up to 1800 Degree F (982 Degree C), an hour, oil covered, made 1325 Degree F (718 Degree C), 16 hours, and some time later air cooled. In the methodology treated condition, Alloy C276 Slatting Coils & Stirps can be pleasingly cool drawn and encased. It is genuinely stiffer than treated steels, for instance, SS 316 and SS 310, and it work bonds rapidly. These Alloy C276 Perforated Coils & Stirps has uniform use hindrance and gives mind blowing high – temperature oxidation resistance moreover",
    Specifications: {
      Specifications: "ASTM / ASME SB575",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B3 Coils & Stirps",
    },
    chemical: {
      Grade: "Hastelloy C276",
      Mo: "15.0-17.0",
      P: ".04 max",
      C: "0.010 max",
      Mn: "1.0 max",
      Si: "0.08 max",
      Co: "2.50 max",
      Ni: "50.99 min*",
      Cr: "14.50 – 16.50",
      Fe: "4.0-7.0",
    },
  },
];

export const HastelloyXCoilsData = [
  {
    text1:
      "Hastelloy X Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Hastelloy X Sheets, ASTM B575 Hastelloy X Sheets, Hastelloy Alloy UNS N06002 Plates, Hastelloy X Coils & Stirps, Hastelloy Alloy Werkstoff NR. 2.4665 Slatting Coils & Stirps, Hastelloy X Hot Rolled Sheets Stockists & Exporters Hastelloy Alloy X Sheets Suppliers, Hastelloy X Plates Supplier, Hastelloy X Coils & Stirps & Circles Stockists In India, Hastelloy Alloy X Plates, DIN 2.4665 Hastelloy X Perforated Sheets, Hastelloy Alloy X Sheets Cut To Size, ASTM B575 Hastelloy X Shim Sheets, Hastelloy X Hot Rolled Plates, ASME SA B575 Hastelloy X Chequered Plates Dealer & Wholesalers.",
    text3:
      "All our Hastelloy X Hot Rolled Sheet are as per the business measures, for example, ASTM/ASME SB 575/619/622/626. We give Hastelloy Alloy X Plates which are 0.5 mm To 100 mm thick which are utilized for Chemical Handling, Gas Handling, Food Products applications. We make Hastelloy X Hot Rolled Plates and Cold Rolled Plates in changing hardness relying upon the employments of our customers. We have practical experience in offering Hastelloy X Checkered Plates and Hastelloy X Polished Plates produced using materials, for example, Nickel, Inconel, Hast amalgam, Copper, Brass, Bronze, Titanium, Tantalum, Bismuth, Aluminum, High-Speed Steel, Zinc and Lead and so forth. We highly esteem offering a far reaching rundown of Hastelloy Alloy X Coils & Stirps, for example, Hastelloy X Hot Rolled Coils & Stirps and Hastelloy X Cold Rolled Coils & Stirps that are in consistence with the necessary national and worldwide gauges.",
    Specifications: {
      Specifications: "ASTM / ASME SB435",
      Size: "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
      Thickness: "0.1mm to 12 mm Thk",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Hardness: "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
      Grade: "Hastelloy Alloy B3 Coils & Stirps",
    },
    chemical: {
      Grade: "Hastelloy X",
      Mo: "8.00 – 10.00",
      P: ".04 max",
      S: "0.03 max",
      C: "0.05 – 0.15",
      Mn: "1.0 max",
      Si: "1.00 max",
      Co: "0.50 – 2.50",
      Ni: "Balance",
      Cr: "20.50 – 23.00",
      Fe: "17.00 – 20.00",
    },
  },
];

export const DuplexS31803CoilsData = [
  {
    text1:
      "Duplex S31803 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Duplex Steel S31803 Plates,Duplex Steel UNS S31803 Plates, Duplex Steel S31803 Coils & Stirps,Duplex Steel Hot Rolled Plates Supplier In Mumbai, India, Duplex Steel Werkstoff No 1.4462 Sheets, ASTM A240 Duplex Steel S31803 Shim Sheets, Duplex Steel S32205 Cold Rolled Plates, Duplex Steel S31803 Slatting Coil, Duplex Steel S31803 Perforated Sheets Dealer In India. Distributors Of ASME SA240 Duplex Steel S31803 Coils & Stirps, Duplex Steel S31803 Strips Stockist, Duplex Steel S31803 Plate Cut To Size, Duplex Steel Grade S32205 Polished Plates Suppliers",
    text3:
      "The explanation for this huge number of use of Duplex S31803 Coils & Stirps is that they have particular extraordinary case properties. The circle has amazing limitation towards use; the bend other than has the property of oxidation hindrance at high temperature and can withstand high temperature. The turns get-togethers' inconceivable weldability likewise, all these astonishing properties of these circle makes it gainful in the social affair and current fields. Right when the party of turns is done they experience different tests like the hardness test, intergranular debilitating test",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
    },
    chemical: {
      Grade: "Duplex S31803",
      N: "0.14 – 0.20",
      Fe: "63.72 min",
      C: "0.030 max",
      Mn: "2.00 max",
      Si: "1.00 max",
      P: "0.030 max",
      S: "0.020 max",
      Cr: "22 – 23",
      Mo: "3.0 – 3.5",
      Ni: "4.50 – 6.50",
    },
  },
];

export const Duplex2101CoilsData = [
  {
    text1:
      "Duplex 2101 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Duplex Steel 2101 Sheets, UNS S32101 Hot Rolled Plates, Ldx 2101 Coils & Stirps Supplier In Pune ASTM A240 Cold Rolled Plates, Lean Duplex Steel UNS S32101 Sheets In Egypt, Lean Duplex Steel 2101 Plates Suppliers In Mumbai, India. Ldx 2101 Coils & Stirps Suppliers In Chennai, ASTM A240 Cold Rolled Plates Exporter In Coimbatore, ASTM A240 Lean Duplex Steel Sheet In Saudi Arabia, UNS S32101 Lean Duplex Plate Exporter In Mumbai, India",
    text3:
      "Our ASTM A240 Lean Duplex Steel Sheet gives better ensured crumbling square, yet for a fantastic bit of the Duplex S31803 at present passed on in like way agrees to Duplex S31803. Meanwhile, we produce five star Duplex ASTM A240 UNS S32101 Cold Rolled Plates that have a mixed microstructure of austenite and ferrite, the truth being to make a 50/50 mix, paying little personality to the course that in business composites, the mix may be 40/60 in particular. Lean duplex cemented steels have high bore got together with use obstruction when showed up distinctively in connection to Austenitic appraisals like 316L. This appraisal has stable cost inferable from low nickel and molybdenum substance. This can unquestionably substitute standard austenitic appraisals like 304, 304L and even 316L in various conditions.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      " Grade": "Duplex Steel 2101 | UNS S32101 | EN 1.4162",
    },
    chemical: {
      Grade: "Duplex S32101",
      N: "0.2-0.25\t",
      C: "< 0.04",
      Mn: "4.0-6.0",
      Cr: "21.0-22.0",
      Mo: "3.0 – 3.5",
      EN: "1.4162",
      Ni: "1.35-1.7\t",
      Cu: "0.1-0.8",
    },
  },
];

export const Duplex2205CoilsData = [
  {
    text1:
      "Duplex 2205 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Duplex 2205 Sheet, Duplex 2205 Plate, Manufacture Duplex Steel 2205 Sheet, ASTM A240 Duplex 2205 Sheet, UNS S31803 Duplex Steel 2205 Plate, Duplex Steel 2205 Coils & Stirps Supplier In Mumbai, Duplex 2205 Chequered Plates, Duplex 2205 Cold Rolled Sheets Exporter, Duplex Steel JIS SUS 2205 Sheets, Duplex Werkstoff Nr. 1.4462 Coils & Stirps Stockholder In India",
    text3:
      "The 2205 is the most completely utilized of the duplex treated steels including over 80% of the duplex cemented steel advance. The 2205 compound gives better crumbling opposition in different conditions where 316L is generally utilized with an additional bit of breathing room of its better return quality. The entirety of the 2205 amalgams are metallographically inspected to guarantee that the sent thing is free from nearness of unbalanced stages, for example, sigma. It is as a rule utilized in kind of welded pipe or adjust and empty segments. The composite has besides been applied as a kept and welded sheet thing in conditions where protection from general usage and chloride stress deterioration separating is basic.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps , Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      " Grade": "Duplex Steel 2205 | UNS S31803/S32205",
    },
    chemical: {
      Grade: "Duplex 2205",
      N: "0.14-0.20",
      S: "0.02 max",
      C: "< 0.03",
      Mn: "< 2.0",
      Cr: "22.0-23.0",
      Mo: "3.0 – 3.5",
      "P ": "0.03 max",
      Ni: "4.5-6.5",
      "Si ": "1 max",
    },
  },
];

export const Duplex2304CoilsData = [
  {
    text1:
      "Duplex 2304/S32304 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Duplex Steel 2304 Sheets, Duplex Steel 2304 Hot Rolled Plates In Malaysia, UNS S32304 Hot Rolled Plates In Nigeria, Alloy 2304 Sheets Tube In SOUTH AFRICA, ASTM A240 Duplex Steel UNS S32304 Sheets, UNS S32304 Duplex Steel Sheets. Duplex Steel S32304 Slatting Sheet, UNS S32304 Duplex Steel Hot Rolled Plates In Australia, ASTM A240 Duplex Steel UNS S32304 Sheets In USA, UNS S32304 Duplex Steel Seamless Slitting Coils & Stirps",
    text3:
      "Making temperature for these Duplex Steel S32304 Slatting Plate ought to be 1100 Degree C – 1250 Degree C, where re – heat practically identical to ordinarily as huge and cool in still air. Duplex Stainless Steel UNS S32304 Perforated Sheets is two - orchestrate, ferritic and austenitic steel by strategies for having 22 percent of chromium, 3 percent of molybdenum, 5 percent - 6 percent of nickel composite. Our Duplex Steel UNS S32304 Coils & Stirps gives better ensured use confinement, yet for a colossal bit of the Duplex S32304 beginning at now made in like way consents to Duplex S32304. Meanwhile, we produce fantastic Duplex Steel UNS S32304 Plates that have a mixed microstructure of austenite and ferrite, the truth being to make a 50/50 mix, offering little appreciation to the way that in business composites, the mix may be 40/60 in particular.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Thickness: "4mm-100mm",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      " Grade": "Duplex Steel 2304 | UNS S32304",
    },
    chemical: {
      Grade: "Duplex Steel 2304 | UNS S32304",
      N: "0.05-0.20",
      S: "0,015\t",
      CU: "0.10-0.60",
      B: "35 PPM",
      C: "0,030",
      Mn: "2,00",
      Cr: "22.0-24.0",
      Mo: "0.10 – 0.60",
      "P ": "0,035",
      Ni: "3.5-5.50",
      "Si ": "1,00\t",
    },
  },
];

export const Duplex2507CoilsData = [
  {
    text1:
      "SuperDuplex 2507 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "UNS S32750 Super Duplex Steel 2507 Coils & Strips|EN X2 Cr Ni MoN 25.7.4 Super Duplex Steel 2507 Coils|Super Duplex Steel 2507 Strips|Super Duplex Steel 2507 Coils & Strips Exporter In India|ASTM A240 Super Duplex Steel 2507 Coils & Strips|ASME SA240 Super Duplex Steel 2507 Coils & Strips Exporter, Super Duplex Steel 2507 Perforated Sheet|AFNOR Z3 CN 25.06 Az Super Duplex Steel 2507 Chequered Plate|2507 Stainless| 1.4410 Super Duplex Steel 2507 Coils & Strips|Duplex Steel 2507 Shim Sheet Coils & Strips Stockist|Super Duplex Steel 2507 Coils & Strips Supplier In Mumbai",
    text3:
      "We are Suppliers and Exporter of Super Duplex Steel 2507 Coils & Stirps and Strips In India, Mumbai. we produce our materials using fantastic rough materials for high resistance of our thing. we in like manner give various assessments ASTM A240, ASME SA240. we offer distinctive sort of Super Duplex 2507 Coils & Stirps and Strips Such as Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Perforated Sheet, Checkered Plate, Strip, Flats, Blank (Circle), Ring (Flange). we in like manner take on clients requests as indicated by their subtleties. Excessively Duplex 2507 (UNS S32750) Sheets and Plates is an unnecessarily duplex treated steel with 25% chromium, 4% molybdenum, and 7% nickel proposed for referencing applications which require remarkable quality and breaking down block, for example, substance framework, petrochemical, and seawater hardware.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Application:
        "Oil and gas industry equipment, Offshore platforms, heat exchangers, process and service water systems, fire-fighting systems, injection and ballast water systems, Chemical process industries, heat exchangers, vessels, and piping, Desalination plants, high pressure RO-plant and seawater piping, Mechanical and structural components, high strength, corrosion-resistant parts, Power industry FGD systems, utility and industrial scrubber systems, absorber towers, ducting, and piping.",
      Thickness: "5mm To 50mm & above",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      Grade: "Super Duplex Steel 2507 (UNS S32750)",
      "Other services":
        "Heat treatment, Annealing, Pickling, Polish, Electroplating, Anodizing, Rolling, Cutting, Forging, etc.",
    },
    chemical: {
      Grade: "Super Duplex 2507",
      N: ".27",
      C: "0.020",
      Cr: "25",
      Mo: "4.0",
      Other: "S=0.001",
    },
  },
];

export const DuplexS32750CoilsData = [
  {
    text1:
      "SuperDuplex S32750/S32760 Coils & Stirps Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "Super Duplex Steel UNS S32750 Sheet, Super Duplex Steel UNS S32760 Coils & Stirps, Super Duplex Steel Sheets & Plates Exporters, DIN 1.4462 Super Duplex Steel Plates, Super Duplex Steel UNS S32760 Coils & Stirps Supplier, UNS S32750 Super Duplex Steel Sheets & Coils & Stirps, WERKSTOFF NR. 1.4462 Sheets Suppliers In India, Super Duplex Steel UNS S32750 Plate, Super Duplex Steel S32750 Chequered Plates, Super Duplex Steel UNS S32760 Sheet, UNS S32760 Super Duplex Slitting Coils & Stirps, ASTM A240 Super Duplex Steel Polished Sheets, ASME SA 240 Super Duplex Diamond Plates, UNS S32760 Super Duplex Shim Sheet, Super Duplex Steel 2507 Hot Rolled Plates Supplier",
    text3:
      "An inordinate measure of Duplex S32750/S32760 Coils & Stirps are convincing and best a motivation for money for whole course of action appears. Unadulterated and attempted material uses in progression of these turns for reviving its quality. Sharp age of these turns dismiss any dimensional oversights and creates surface completion. Made circles examined by untouchables for quality explanation then it will be squashed in the moves sort of packs for solace transporting.",
    Specifications: {
      Specifications: "ASTM A240 / ASME SA240",
      Application:
        "Oil and gas industry equipment, Offshore platforms, heat exchangers, process and service water systems, fire-fighting systems, injection and ballast water systems, Chemical process industries, heat exchangers, vessels, and piping, Desalination plants, high pressure RO-plant and seawater piping, Mechanical and structural components, high strength, corrosion-resistant parts, Power industry FGD systems, utility and industrial scrubber systems, absorber towers, ducting, and piping.",
      Thickness: "5mm To 50mm & above",
      Width:
        "1000mm, 1219mm, 1500mm, 1800mm, 2000mm, 2500mm, 3000mm, 3500mm, etc",
      Length: "2000mm, 2440mm, 3000mm, 5800mm, 6000mm, etc",
      Surface:
        "2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc",
      Finish:
        "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
      Form: "Coils & Stirps, Foils, Rolls, Plain Sheet, Shim Sheet, Designer Sheet, Chequered Plate, Strip, Flats, Blank (Circle), Ring (Flange) etc.",
      Grade: "Super Duplex Stee S32750",
      "Other services":
        "Heat treatment, Annealing, Pickling, Polish, Electroplating, Anodizing, Rolling, Cutting, Forging, etc.",
    },
    chemical: {
      Grade: "Super Duplex S32750",
      S: "0.020 max",
      N: "0.24 – 0.32",
      Fe: "58.095 min",
      C: "0.030 max",
      Mn: "1.20max",
      Si: "0.80 max",
      Cr: "24 – 26",
      Mo: "3 – 5",
      P: "0.035 max",
      Ni: "6 – 8",
    },
  },
];
